import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, numberWithCommas } from "../utils";
import moment from "moment-timezone";
import HighchartsCustomEvents from "highcharts-custom-events";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);
class VolumeOfNewsChart extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.chartComponent = React.createRef();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    isHourly(data) {
        if (data.xs.length < 2) return false;
        return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
    }

    getOptions = () => {
        // let data = this.props.data.data;

        let plotComaprisiondata;

        let plotComaprisiondataCondition = this.props.comparisionData && this.props.comparisionData.data.total.length >= this.props.data.data.total.length;

        if (plotComaprisiondataCondition && this.props.data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(this.props.data.data));

            this.props.comparisionData.data.total.forEach((element, ind) => {
                if (plotComaprisiondata.total[ind]) {
                    plotComaprisiondata.total[ind].originalX = plotComaprisiondata.total[ind].x;
                    plotComaprisiondata.total[ind].x = element.x;
                    plotComaprisiondata.online[ind].originalX = plotComaprisiondata.online[ind].x;
                    plotComaprisiondata.online[ind].x = element.x;
                    plotComaprisiondata.offline[ind].originalX = plotComaprisiondata.offline[ind].x;
                    plotComaprisiondata.offline[ind].x = element.x;
                }
            });
        } else {
            if (this.props.comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(this.props.comparisionData.data));
                this.props.data &&
                    this.props.data.data.total.forEach((element, ind) => {
                        if (plotComaprisiondata.total[ind]) {
                            plotComaprisiondata.total[ind].originalX = plotComaprisiondata.total[ind].x;
                            plotComaprisiondata.total[ind].x = element.x;
                            plotComaprisiondata.online[ind].originalX = plotComaprisiondata.online[ind].x;
                            plotComaprisiondata.online[ind].x = element.x;
                            plotComaprisiondata.offline[ind].originalX = plotComaprisiondata.offline[ind].x;
                            plotComaprisiondata.offline[ind].x = element.x;
                        }
                    });
            }
        }

        let serObj = this.props.comparisionData
            ? [
                  {
                      name: "Online",
                      data:
                          this.props.comparisionData.data.total.length >= this.props.data.data.total.length
                              ? plotComaprisiondata.online
                              : this.props.data.data.online,
                      //data: this.props.data.data.online,
                      dataLabels: {
                          color: "red",
                      },
                      color: getSentimentColor("positive"),
                  },
                  {
                      name: "Online comparisionData",
                      data:
                          this.props.comparisionData.data.total.length < this.props.data.data.total.length
                              ? plotComaprisiondata.online
                              : this.props.comparisionData.data.online,
                      //  data: this.props.comparisionData.data.online,
                      dataLabels: {
                          color: "red",
                      },
                      // xAxis: 1,
                      color: getSentimentColor("positive") + "55",
                      linkedTo: ":previous",
                      // visible: false,
                  },
                  {
                      name: "Offline",
                      data:
                          this.props.comparisionData.data.total.length >= this.props.data.data.total.length
                              ? plotComaprisiondata.offline
                              : this.props.data.data.offline,
                      //  data: this.props.data.data.offline,
                      color: getSentimentColor("negative"),
                  },
                  {
                      name: "Offline comparisionData",
                      data:
                          this.props.comparisionData.data.total.length < this.props.data.data.total.length
                              ? plotComaprisiondata.offline
                              : this.props.comparisionData.data.offline,
                      // data: this.props.comparisionData.data.offline,
                      color: getSentimentColor("negative") + "55",
                      //xAxis: 1,
                      linkedTo: ":previous",
                  },
                  {
                      name: "Total",
                      data:
                          this.props.comparisionData.data.total.length >= this.props.data.data.total.length
                              ? plotComaprisiondata.total
                              : this.props.data.data.total,
                      //  data: this.props.data.data.total,
                      color: getSentimentColor("total"),
                      visible: false,
                  },

                  {
                      name: "Total comparisionData",
                      data:
                          this.props.comparisionData.data.total.length < this.props.data.data.total.length
                              ? plotComaprisiondata.total
                              : this.props.comparisionData.data.total,
                      // data: this.props.comparisionData.data.total,
                      color: getSentimentColor("total") + "55",
                      // xAxis: 1,
                      linkedTo: ":previous",
                      visible: false,
                  },
              ]
            : [
                  {
                      name: "Online",
                      data: this.props.data.data.online,
                      dataLabels: {
                          color: "red",
                      },
                      color: getSentimentColor("positive"),
                  },
                  {
                      name: "Offline",
                      data: this.props.data.data.offline,
                      color: getSentimentColor("negative"),
                  },
                  {
                      name: "Total",
                      data: this.props.data.data.total,
                      color: getSentimentColor("total"),
                  },
              ];

        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        const optionsOverTime = {
            chart: {
                className: "skiptranslate",
                type: "spline",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                // labels: {
                //     style: {
                //         textTransform: "normal",
                //     },
                // },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                // gridLineDashStyle: "shortdash",
                // gridLineColor: "#ccd6eb",
                // lineColor: "#000",
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "volume of news",
            },
            legend: {
                enabled: this.props.showLegend,
                // itemStyle: {
                //     fontWeight: 500,
                //     fontFamily: "'Roboto', sans-serif",
                //     textTransform: "normal",
                // },
                alignColumns: false,
            },
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    events: {
                        legendItemClick: function () {
                            self.props.legendClick(true);
                        },
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("55");
                            let secondColorPoint = this.points[0]?.color.endsWith("55");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }
                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }

                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return optionsOverTime;
    };

    render() {
        return this.props.expandWidget ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        ) : (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default VolumeOfNewsChart;
